



















































import { defineComponent, PropType, computed, ref } from '@vue/composition-api';
import { CommentDisplay } from '@oare/types';
import sl from '@/serviceLocator';
import { formatTimestamp } from '@/utils';

export default defineComponent({
  props: {
    comment: {
      type: Object as PropType<CommentDisplay>,
      required: true,
    },
  },
  setup({ comment }, { emit }) {
    const store = sl.get('store');
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');

    const confirmDeleteDialog = ref(false);
    const loading = ref(false);

    const canDeleteComment = computed(() => {
      const user = store.getters.user;

      if (!user) {
        return false;
      }

      if (comment.deleted) {
        return false;
      }

      return comment.userUuid === user.uuid || user.isAdmin;
    });

    const deleteComment = async () => {
      try {
        loading.value = true;
        await server.deleteComment(comment.uuid);

        actions.showSnackbar('Successfully deleted the comment');
        confirmDeleteDialog.value = false;
        emit('deleted');
      } catch (err) {
        actions.showErrorSnackbar('Failed to delete the comment', err as Error);
      } finally {
        loading.value = false;
      }
    };

    return {
      canDeleteComment,
      deleteComment,
      confirmDeleteDialog,
      loading,
      formatTimestamp,
    };
  },
});
